import { Input } from "@App/Components/common/Input";
import { SubmitButton } from "@App/Components/atoms/whitelabel/home/SubmitButton";
import type { FormEvent } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import { actionCreators } from "@App/state";
import { useDispatch, useSelector } from "react-redux";
import type { State } from "@App/state";

interface DamageOrderNumberFormProps {
  onSuccess: () => void;
}

export function DamageOrderNumberForm({ onSuccess }: DamageOrderNumberFormProps) {
  const dispatch = useDispatch();
  const { setClaimNumber, setMessage } = bindActionCreators(actionCreators, dispatch);
  const existingMessage = useSelector((state: State) => state.orders.message);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const fd = new FormData(event.currentTarget);
    const damageNumber = fd.get("damageNumber") as string;
    const orderNumber = fd.get("orderNumber") as string;
    setClaimNumber(damageNumber);
    setMessage([`Auftragsnummer: ${orderNumber}`, existingMessage].filter(Boolean).join("\n\n"));
    onSuccess();
  };

  return (
    <form id={"damage-order-form"} onSubmit={handleSubmit} className={"flex flex-col my-4"}>
      <div className={"flex flex-col gap-5 md:flex-row md:gap-5"}>
        <div className={"flex flex-col"}>
          <label htmlFor={"damageNumber"} className={"text-sm"}>
            Schadennummer
          </label>
          <Input
            id={"damageNumber"}
            name={"damageNumber"}
            placeholder={"SDEXXXXXX"}
            required
            minLength={9}
            maxLength={9}
          />
        </div>
        <div className={"flex flex-col"}>
          <label htmlFor={"orderNumber"} className={"text-sm"}>
            Auftragsnummer
          </label>
          <Input id={"orderNumber"} name={"orderNumber"} required />
        </div>
      </div>
      <SubmitButton text={"Weiter"} type={"submit"} />
    </form>
  );
}
